export default __webpack_public_path__ + "static/px3-01516e898168a23f2e036b7ae1bbddc0.jpg";